<template>

    <v-app>

        <v-app-bar elevation="2" app clipped-left color="#ebebeb">
            <v-app-bar-nav-icon @click.stop="drawerOpen = !drawerOpen"></v-app-bar-nav-icon>
            <img class="ml-1" contain height="50" :src="require('@/images/kh_logo.png')"/>
        </v-app-bar>

        <v-navigation-drawer  app clipped v-model="drawerOpen">

            <v-list nav>

                <v-list-item link to="/Home">
                    <v-list-item-icon>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link to="/Info">
                    <v-list-item-icon>
                        <v-icon>mdi-information</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Helpful Information</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link to="/Repairs">
                    <v-list-item-icon>
                        <v-icon>mdi-hammer-screwdriver</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Maintenance &amp; Repairs</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- <v-list-item link to="/Billing">
                    <v-list-item-icon>
                        <v-icon>mdi-cash</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Pay Your Bills</v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->

                <v-list-item link to="/MyAccount">
                    <v-list-item-icon>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>My Account</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list>

            <template v-slot:append>
                <v-list nav>
                    <v-list-item link @click="signOut">
                        <v-list-item-icon>
                            <v-icon color="#B0615D">mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title style="color: #B0615D">Sign Out</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </template>

        </v-navigation-drawer>

        <v-main>
            <slot />
        </v-main>

        <v-footer app color="#679E6A" dark>
            <div class="contact-us-message">
                Need help? Give us a ring on <a href="tel:01159652426">0115 965 2426</a> or drop us an email at <a href="mailto:info@killarneyhomes.co.uk">info@killarneyhomes.co.uk</a>
            </div>
        </v-footer>

    </v-app>

</template>

<script lang="ts">
    import Vue from "vue";
    import Component from "vue-class-component";
    import authentication from "@/utilities/Authentication";

    @Component({})
    export default class SignedInLayout extends Vue {

        //
        // -- lifecycle hooks
        //

        mounted() {
            document.body.style.backgroundColor = "#fff";
        }

        //
        // -- properties
        //

        drawerOpen: boolean|null = null

        //
        // -- methods
        //

        signOut() {
            // Not using async / await here so we'll just trust the sign out occurs in the background
            // and rely on error handler if anything screws up.
            authentication.signOut();

            this.$router.push("/");
        }

    }
</script>